import React, {useState} from "react";
import {FieldPath, FieldValues, UseFormRegister, UseFormSetValue} from "react-hook-form";
import LegalCheckbox from "./inputs/LegalCheckbox";
import LegalModal from "./modal/LegalModal";

interface LegalCheckModalProps<T extends FieldValues> {
    name: FieldPath<T>;
    register: UseFormRegister<T>;
    watch: (name: FieldPath<T>) => any;
    setValue: UseFormSetValue<T>;
    errors: any;
    contentKey: string;
    legalLinkKey: string;
}

const LegalCheckModal = React.forwardRef<HTMLInputElement, LegalCheckModalProps<any>>(({
    name, 
    register,
    watch,
    setValue,
    errors,
    contentKey,
    legalLinkKey,
}, ref) => {
    const [openModal, setOpenModal] = useState(false);

    const checkboxValue = watch(name);

    return (
        <>
            <LegalCheckbox
                ref={ref}
                name={name}
                register={register}
                error={errors[name]?.message as string}
                defaultChecked={checkboxValue}
                onOpenModal={() => setOpenModal(true)}
                legalLinkKey={legalLinkKey}
            />
            <LegalModal
                isOpen={openModal}
                onAccept={() => {
                    setValue(name, true, { shouldValidate: true });
                    setOpenModal(false);
                }}
                onClose={() => setOpenModal(false)}
                titleKey={legalLinkKey}
                content={contentKey}
            />
        </>
    );
});

LegalCheckModal.displayName = "LegalCheckModal";

export default LegalCheckModal;
